import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import ItemPeriodicidade from "model/periodicidade/ItemPeriodicidade";
import Periodicidade from "model/periodicidade/Periodicidade";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useEffect } from "react";
import { PeriodicidadeService } from "service/periodicidade/PeriodicidadeService";
import { converterData } from "utils/convert";

type Props = {
    visible: boolean;
    value: Periodicidade
    onChange: (value: Periodicidade) => void;
    onConfirm: (value: Periodicidade) => void;
    onCancel: () => void;
}

const periodicidadeService = new PeriodicidadeService()

export default function ModalSelecaoPeriodicidadeIndicador(props: Props) {
    const { msgAlerta } = useToastContext();
    useEffect(() => {
        if (!props.value) {
            props.onChange(new Periodicidade())
        }
    }, [])

    const footer = <div>
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-danger" onClick={props.onCancel} />
        <Button label="Confirmar" icon="pi pi-check" className="p-button-text" onClick={() => podeConfirmar() ? props.onConfirm(props.value) : null} />
    </div>

    function podeConfirmar(): boolean {
        if (!props.value?.personalizada) {
            if (!props.value?.periodo) {
                msgAlerta("Periodicidade", "Periodo é obrigatório")
                return false;
            }
            if (!props.value?.tipoPeriodo) {
                msgAlerta("Periodicidade", "Tipo de periodo é obrigatório")
                return false;
            }
            if (!periodicidadeService.getTipoPeriodo(props.value?.tipoPeriodo)) {
                msgAlerta("Periodicidade", "Selecione um tipo de período válido")
                return false;
            }
        } else {
            if (!periodicidadeService.getTipoPeriodoPersonalizado(props.value?.tipoPeriodo)) {
                msgAlerta("Periodicidade", "Selecione um tipo de período válido")
                return false;
            }
        }
        return true;
    }

    return (
        <Dialog visible={props.visible} style={{ width: '65vw', minHeight: "50vh" }} header="Selecione a periodicidade" footer={footer} modal={true} onHide={props.onCancel}>
            <div style={{ width: "100%", display: "flex", flexDirection: "column", rowGap: 16 }}>
                <div style={{display: "flex", flexDirection: "column"}}>
                    <label  style={{  fontWeight: "bold" }}>Última geração</label>
                    <InputText value={props.value?.dataUltimaGeracao ? converterData(props.value.dataUltimaGeracao) : ""} readOnly style={{width: 150}} />
                </div>

                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Label label="Periodo" obrigatorio={true} />
                    <div style={{ width: "100%" }}>
                        <InputNumber
                            style={{ width: "10%" }}
                            inputStyle={{ width: "100%" }}
                            value={props.value?.periodo}
                            onChange={(e) => props.onChange({ ...props.value, periodo: e.value as number })}
                        />
                        <Dropdown
                            style={{ width: "30%", marginLeft: 8 }}
                            options={periodicidadeService.getTiposPeriodo()}
                            value={props.value?.tipoPeriodo} optionLabel="label" optionValue="value"
                            onChange={(e) => props.onChange({ ...props.value, tipoPeriodo: e.value as string })}
                        />
                    </div>

                </div>
            </div>
        </Dialog>
    )
}